module.exports = __webpack_public_path__ + "img/action-1.5ba77db6.svg";